export default {"src":"/_next/static/media/happy-dog.6fd6f7bb.svg","height":101,"width":100};